'use strict'

const { ancestorRequiresLogin, pageRequiresLoginFlag } = require('../../../shared/view-visibility.js')

const VIEW_ICON_TIPS = {
  drag: 'Drag to reorder or move this view',
  duplicate: 'Duplicate this view onto a page that uses the same spreadsheet or a linked one',
  move: 'Move this view onto a page that uses the same spreadsheet or a linked one',
  css: "Edit this view's CSS",
  embed: 'Choose how to embed, starting from this view',
  remove: 'Remove this view',
  pageCss: "Edit this page's CSS",
  columnFormat: "Set this column's width, and whether a wide view scrolls or uses its mobile layout"
}

function viewIconTip (kind) {

  return VIEW_ICON_TIPS[kind] || ''
}

function viewLoginTip (view) {

  if (view && view.requiresLogin) {

    return 'Shown only when logged in. Click to always show this view'
  }

  return 'Show this view only when a user is logged in'
}

function viewHideWhenLoggedInTip (view) {

  if (view && view.hideWhenLoggedIn) {

    return 'Hidden when logged in. Click to always show this view'
  }

  return 'Hide this view when a user is logged in'
}

function userPermissionTip (hasRules, subject) {

  const target = subject || 'this page'

  if (hasRules) return `User permission rules limit who can see ${target}`

  return `Show or hide ${target} based on the signed-in user's fields and related records`
}

function pageOpenTip (hasRules) {

  if (hasRules) return 'Presentation rules run when this page opens. They do not control access'

  return 'Show a banner or redirect when this page opens. This is presentation, not access'
}

function pageLoginTip (page, pages) {

  if (ancestorRequiresLogin(page, pages)) {

    return 'Login is required because a parent page requires login'
  }

  if (pageRequiresLoginFlag(page)) {

    return 'Login is required to view this page. Click to allow anyone'
  }

  return 'Anyone can view this page. Click to require login'
}

function viewSpreadsheetTip (spreadsheetTitle, options) {

  const sheet = spreadsheetTitle || 'its spreadsheet'
  const filtered = options && options.filterByPageRecord
  const via = options && options.relationshipTitle ? ` via ${options.relationshipTitle}` : ''

  if (filtered) {

    return `Reads records from ${sheet}, limited to the page record${via}`
  }

  return `Reads records from ${sheet}`
}

module.exports = {
  viewIconTip,
  viewLoginTip,
  viewHideWhenLoggedInTip,
  viewSpreadsheetTip,
  pageLoginTip,
  userPermissionTip,
  pageOpenTip
}
